import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { IRiskCategory } from '../interfaces/IRiskCategory';

export async function fetchRiskCategories(): Promise<IRiskCategory[]> {
  return apiGet<IRiskCategory[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/risk-categories`);
}

export async function createRiskCategory(riskCategory: Omit<IRiskCategory, 'id'>): Promise<void> {
  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/risk-categories`,
    body: riskCategory,
  });
}

export async function updateRiskCategory(riskCategory: IRiskCategory): Promise<void> {
  const { id, ...data } = riskCategory;

  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/risk-categories/${id}`, data);
}
